// extracted by mini-css-extract-plugin
export var root = "_2d597e5555fe2660ab6d68aeda749786-css";
export var root_align_end = "cbdc0f5deb9aed2b29a58e13b4512321-css";